import React from "react";
import { Outlet } from "react-router-dom";
import Loader from "./common_nextgen/common_components/Loader";

const App = () => {
  return (
    <>
      <Loader />
      <Outlet />
    </>
  );
};

export default App;